module.exports = __webpack_public_path__ + "media/images/pages/primary-senior-leaders/teach_primary_computing-49c545f375139f4e35f4c48f99d40c7d.svg";